import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { ConfigProvider } from 'antd';
import './i18n'; // Import i18n configuration
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import TasksPage from './pages/TasksPage';
import EmployeesPage from './pages/EmployeesPage';
import AttendancePage from './pages/AttendancePage';
import FeedsPage from './pages/FeedsPage';
import AttendanceEmployeeInfo from './pages/AttendanceEmployeeInfo';
import ProtectedRoute from './components/ProtectedRoute';
import Projects from './pages/Projects';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import PublicHolidays from './pages/PublicHolidays';
import VacationPage from './pages/VacationPage';
import CalendarPage from './pages/CalendarPage';
import ClientProjectPage from './pages/ClientProjectPage';
// Same palette as the mobile admin screens (see src/styles/ui.css)
const theme = {
  token: {
    colorPrimary: '#0A7EA4',
    colorLink: '#0A7EA4',
    colorBgLayout: '#F4F6F9',
    colorText: '#0F172A',
    colorTextSecondary: '#475569',
    colorBorder: '#E2E8F0',
    colorBorderSecondary: '#EEF1F5',
    colorSuccess: '#15803D',
    colorWarning: '#B45309',
    colorError: '#DC2626',
    borderRadius: 10,
  },
};

const App: React.FC = () => {
  return (
    <ConfigProvider theme={theme}>
    <Router>
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            duration: 3000,
            style: {
              background: '#52c41a',
            },
          },
          error: {
            duration: 4000,
            style: {
              background: '#ff4d4f',
            },
          },
        }}
      />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/employees" element={<EmployeesPage />} />
          <Route path="/attendance" element={<AttendancePage />} />
          <Route path="/attendance-employee/:id" element={<AttendanceEmployeeInfo />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/feeds" element={<FeedsPage />} />
          <Route path="/tasks" element={<TasksPage />} />
          <Route path="/calendar-events" element={<CalendarPage />} />
          <Route path="/public-holidays" element={<PublicHolidays />} />
          <Route path="/vacation" element={<VacationPage />} />
        </Route>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        {/* Client link: read-only project view, no login */}
        <Route path="/p/:token" element={<ClientProjectPage />} />
      </Routes>
    </Router>
    </ConfigProvider>
  );
};

export default App;
